import { createSelector } from '@ngrx/store';
import { LoyaltyProgram, LoyaltyProgramCategory } from '@rd/types';
import { getRedeemCashV2State, RedeemCashV2State } from '../reducers/index';
import { RedeemCashLoyaltyProgramState } from '../reducers/redeem-cash-loyalty-program.reducer';

const getRedeemCashLoyaltyProgramState = createSelector(
  getRedeemCashV2State,
  (state: RedeemCashV2State) => state.redeemCashLoyaltyPrograms,
);

const getLoyaltyPrograms = (
  state: RedeemCashLoyaltyProgramState,
): LoyaltyProgram[] | null => state.loyaltyPrograms;

export const getRedeemCashLoyaltyPrograms = createSelector(
  getRedeemCashLoyaltyProgramState,
  getLoyaltyPrograms,
);

export const getFetchRedeemCashLoyaltyProgramError = createSelector(
  getRedeemCashLoyaltyProgramState,
  (state) => state.error,
);

export const getFetchRedeemCashLoyaltyProgramLoading = createSelector(
  getRedeemCashLoyaltyProgramState,
  (state) => state.loading,
);

export const getRedeemCashLoyaltyProgramByCategory = (
  categoryName: LoyaltyProgramCategory,
) =>
  createSelector(
    // @ts-ignore
    getRedeemCashLoyaltyPrograms,
    (loyaltyPrograms: LoyaltyProgram[]): LoyaltyProgram | null => {
      // @ts-ignore
      return loyaltyPrograms.find(
        (loyaltyProgram) => loyaltyProgram.category === categoryName,
      );
    },
  );
